import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
@autobind
class Condicional extends React.Component {
  render() {
    return (
      <Lookup
        labelKey="descricao"
        valueKey="id"
        options={[
          {
            id: '1',
            descricao: this.props.intl.formatMessage({ id: 'sim' }),
          },
          {
            id: '2',
            descricao: this.props.intl.formatMessage({ id: 'nao' }),
          },
        ]}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(Condicional));
